/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1SerievideoVideoidLangsMutationRequest,
  PostApiV1SerievideoVideoidLangsMutationResponse,
  PostApiV1SerievideoVideoidLangsPathParams,
  PostApiV1SerievideoVideoidLangsQueryParams,
  PostApiV1SerievideoVideoidLangs400,
  PostApiV1SerievideoVideoidLangs401,
  PostApiV1SerievideoVideoidLangs404,
  PostApiV1SerievideoVideoidLangs500,
} from "../../types/serieVideoIdiomasController/PostApiV1SerievideoVideoidLangs.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1SerievideoVideoidLangs } from "../../clients/serieVideoIdiomasController/postApiV1SerievideoVideoidLangs.ts";

export const postApiV1SerievideoVideoidLangsMutationKey = () =>
  [{ url: "/api/v1/serievideo/:videoId/langs" }] as const;

export type PostApiV1SerievideoVideoidLangsMutationKey = ReturnType<
  typeof postApiV1SerievideoVideoidLangsMutationKey
>;

export function postApiV1SerievideoVideoidLangsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1SerievideoVideoidLangsMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1SerievideoVideoidLangsMutationKey();
  return mutationOptions<
    PostApiV1SerievideoVideoidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoVideoidLangs400
      | PostApiV1SerievideoVideoidLangs401
      | PostApiV1SerievideoVideoidLangs404
      | PostApiV1SerievideoVideoidLangs500
    >,
    {
      videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"];
      data?: PostApiV1SerievideoVideoidLangsMutationRequest;
      params?: PostApiV1SerievideoVideoidLangsQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ videoId, data, params }) => {
      return postApiV1SerievideoVideoidLangs(videoId, data, params, config);
    },
  });
}

/**
 * @description Cria uma nova tradução (idioma) para o vídeo. **(Requer Authorization para autenticação)**
 * @summary Criar idioma do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs}
 */
export function usePostApiV1SerievideoVideoidLangs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1SerievideoVideoidLangsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1SerievideoVideoidLangs400
        | PostApiV1SerievideoVideoidLangs401
        | PostApiV1SerievideoVideoidLangs404
        | PostApiV1SerievideoVideoidLangs500
      >,
      {
        videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"];
        data?: PostApiV1SerievideoVideoidLangsMutationRequest;
        params?: PostApiV1SerievideoVideoidLangsQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1SerievideoVideoidLangsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1SerievideoVideoidLangsMutationKey();

  const baseOptions = postApiV1SerievideoVideoidLangsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1SerievideoVideoidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoVideoidLangs400
      | PostApiV1SerievideoVideoidLangs401
      | PostApiV1SerievideoVideoidLangs404
      | PostApiV1SerievideoVideoidLangs500
    >,
    {
      videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"];
      data?: PostApiV1SerievideoVideoidLangsMutationRequest;
      params?: PostApiV1SerievideoVideoidLangsQueryParams;
    },
    TContext
  >;

  return useMutation<
    PostApiV1SerievideoVideoidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoVideoidLangs400
      | PostApiV1SerievideoVideoidLangs401
      | PostApiV1SerievideoVideoidLangs404
      | PostApiV1SerievideoVideoidLangs500
    >,
    {
      videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"];
      data?: PostApiV1SerievideoVideoidLangsMutationRequest;
      params?: PostApiV1SerievideoVideoidLangsQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1SerievideoVideoidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoVideoidLangs400
      | PostApiV1SerievideoVideoidLangs401
      | PostApiV1SerievideoVideoidLangs404
      | PostApiV1SerievideoVideoidLangs500
    >,
    {
      videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"];
      data?: PostApiV1SerievideoVideoidLangsMutationRequest;
      params?: PostApiV1SerievideoVideoidLangsQueryParams;
    },
    TContext
  >;
}
